import React from "react";

export default function ShoppingBagIcon({
    strokeWidth = 3,
    className = "w-1",
    stroke = "currentColor",
    fill = "none",
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            fill={fill}
            viewBox="0 0 24 24"
            stroke={stroke}
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M16 11V7a4 4 0 00-8 0v4M5 9h14l-1.45 11.022A2 2 0 0115.56 22H8.44a2 2 0 01-1.99-1.978L5 9z"
            />
        </svg>
    );
}
